import React from 'react';

function GallerySection({ mockups, imageOrientations, onImageClick }) {
  if (mockups.length === 0) {
    return (
      <div className="gallery-section">
        <div className="gallery-container">
          <p className="no-mockups">No mockups available for this app</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-section">
      <div className="gallery-container">
        <div className="gallery-grid">
          {mockups.map((mockupUrl, index) => {
            const currentOrientation = imageOrientations[index] || 'portrait';
            const prevOrientation = index > 0 ? (imageOrientations[index - 1] || 'portrait') : null;
            const showBreak = prevOrientation && currentOrientation !== prevOrientation;
            
            return (
              <React.Fragment key={index}>
                {showBreak && <div className="gallery-break"></div>}
                <div 
                  className={`gallery-item ${currentOrientation}`}
                  onClick={() => onImageClick(index)}
                >
                  <img src={mockupUrl} alt={`Mockup ${index + 1}`} />
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default GallerySection;
